<div class="container-fluid grey-bg form-wrapper">
    <div class="row">
        <div class="col-12">
            <div class="form-box">
                <div class="top-detail">
                    <a href="/" title="Back to Home"><img alt="world of sweets logo"
                            src="../../assets/images/bonds-logo-footer.svg" /></a>
                    <h1>Forgot Password?</h1>
                    <p>To reset password, please enter your email address.</p>
                </div>

                <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()" autocomplete="off">
                    <div class="form-group mb-0">
                        <label>Email address <sup>*</sup></label>
                        <input type="email" maxLength="100" class="form-control" placeholder="E.g. mert.ryder@gmail.com" formControlName="email">
                        <div *ngIf="submitted && forgotPasswordForm.controls.email.errors" class="error">
                            <div *ngIf="forgotPasswordForm.controls.email.errors.required"><img src="assets/images/error.svg" /> Email is required</div>
                            <div *ngIf="forgotPasswordForm.controls.email.errors.email"><img src="assets/images/error.svg" /> Please check the format of the email ID and provide the correct one</div>
                        </div>
                        <div class="error" *ngIf="submitted && !forgotPasswordForm.controls.email.errors"> {{errMessage}} </div>
                        
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn primary-btn">Submit</button>
                    </div>
                    
                </form>
                <div class="redirect-signup">
                    <p>Remember Password? <a routerLink="/users/login" title="Sign In">Sign In</a></p>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</div>